import React from 'react';
import styles from './styles.module.css';

export default ({ height = '540px', width, src }) => (
  <div className={styles.container} style={{ height, width }}>
    <img src={src} alt="" />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/background-image/index.js